<template>
  <section :style="{ 'max-height': height }" class="scroll-container">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'Scroll',
  props: {
    height: {
      type: String,
      required: false,
      default: '40vh',
    },
  },
}
</script>

<style lang="scss" scoped>

.mr-1 {
  margin-right: .5rem;
}

@import '../_variables.scss';

.scroll-container {
  max-height: 80vh;
  overflow: auto;

  $radius: 3px;

  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar {
    border-radius: $radius;
    background-color: whitesmoke;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: $radius;
    background-color: $teal;
  }
}

.scroll-container {
  display: block;
}

</style>



// WEBPACK FOOTER //
// Scroll.vue?17c40491